// services/participantes/llamadasService.js
import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/llamadas`;

export async function getLlamadas(participanteId) {
  const response = await axios.get(`${baseUrl}/${participanteId}`);
  return response.data;
}

export async function getDetalleLlamada(id) {
  const response = await axios.get(`${baseUrl}/detalle/${id}`);
  return response.data;
}

export async function createLlamada(participanteId, data, userLogin, ip) {

  return axios.post(
    `${baseUrl}/${participanteId}`,
    data,
    {
      headers: {
        "x-usuario-id": userLogin,
        "x-user-ip": ip
      }
    }
  );
}

export async function updateLlamada(id, data, userLogin, ip) {
  const response = await axios.put(
    `${baseUrl}/${id}`,
    data,
    {
      headers: {
        "x-usuario-id": userLogin,
        "x-user-ip": ip
      }
    }
  );
  return response.data;
}

export async function deleteLlamada(id, userLogin, ip) {
  const response = await axios.delete(
    `${baseUrl}/${id}`,
    {
      headers: {
        "x-usuario-id": userLogin,
        "x-user-ip": ip
      }
    }
  );
  return response.data;
}